import { css } from '@emotion/css';

const styles = {
  root: css`
    .MuiFormHelperText-root {
    & span {
       font-family: 'Montserrat Regular' !important;
       font-size: 0.75rem !important;
       letter-spacing: -0.3px !important;
       line-height: 1.33 !important;
      }
    }
  `,
};

export default styles;
